import React, { CSSProperties } from "react";
import { Modal } from "./modal";
import { stylex } from "./stylex";
import { cssVariables } from "./css_variables";

interface DialogProps {
  header?: React.ReactNode;
  footer?: React.ReactNode;
  children?: React.ReactNode;
  isOpen: boolean;
  onRequestClose?: () => void;
  override?: {
    root?: { style?: CSSProperties };
    dialog?: { style?: CSSProperties };
    body?: { style?: CSSProperties };
  };
}

export function Dialog(props: DialogProps) {
  const { isOpen, children, onRequestClose, header, footer, override } = props;

  return (
    <Modal isOpen={isOpen} onRequestClose={onRequestClose} transparent>
      <div style={{ ...styles("root"), ...override?.root?.style }}>
        <div onClick={onRequestClose} style={styles("overlay")} />
        <div style={{ ...styles("dialog"), ...override?.dialog?.style }}>
          {header}
          <div style={{ ...styles("body"), ...override?.body?.style }}>
            {children}
          </div>
          {footer}
        </div>
      </div>
    </Modal>
  );
}

const styles = stylex.create({
  root: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    height: "100%",
    position: "relative",
  },
  overlay: {
    backgroundColor: "rgba(16, 10, 41, 0.7)",
    WebkitBackdropFilter: "blur(6px)",
    backdropFilter: "blur(6px)",
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
  },
  dialog: {
    borderRadius: cssVariables.radius,
    position: "relative",
    backgroundColor: "white",
    zIndex: 1,
  },
  body: {
    maxHeight: "100vh",
    overflow: "auto",
  },
});
